import script from "./ParceirosAdministrar.vue?vue&type=script&setup=true&lang=js"
export * from "./ParceirosAdministrar.vue?vue&type=script&setup=true&lang=js"

import "./ParceirosAdministrar.vue?vue&type=style&index=0&id=cdce1c96&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cdce1c96"]])

export default __exports__